/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AiAssistantCreateRequest } from '../models/AiAssistantCreateRequest';
import type { AiAssistantCreateResponse } from '../models/AiAssistantCreateResponse';
import type { AiAssistantUpdateRequest } from '../models/AiAssistantUpdateRequest';
import type { AiAssistantUpdateResponse } from '../models/AiAssistantUpdateResponse';
import type { AITemplateDto } from '../models/AITemplateDto';
import type { AITemplateDtoPagedListData } from '../models/AITemplateDtoPagedListData';
import type { AITemplateInput } from '../models/AITemplateInput';
import type { AIVehicleDataDto } from '../models/AIVehicleDataDto';
import type { AIVehicleDataDtoPagedListData } from '../models/AIVehicleDataDtoPagedListData';
import type { AIVehicleDataInput } from '../models/AIVehicleDataInput';
import type { AIVehicleDataSetCurrentInput } from '../models/AIVehicleDataSetCurrentInput';
import type { AIVehicleModelDataDto } from '../models/AIVehicleModelDataDto';
import type { ContractData } from '../models/ContractData';
import type { ConvertedPartPdfFullModel } from '../models/ConvertedPartPdfFullModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AiSettingsService {

  /**
   * @returns AIVehicleModelDataDto Success
   * @throws ApiError
   */
  public static getAiSettingsVehicleDataModelData(): CancelablePromise<AIVehicleModelDataDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ai-settings/vehicle-data/model-data',
    });
  }

  /**
   * @param search 
   * @param model 
   * @param modelId 
   * @param current 
   * @param modelYear 
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns AIVehicleDataDtoPagedListData Success
   * @throws ApiError
   */
  public static getAiSettingsVehicleData(
search?: string,
model?: string,
modelId?: number,
current?: boolean,
modelYear?: string,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<AIVehicleDataDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ai-settings/vehicle-data',
      query: {
        'Search': search,
        'Model': model,
        'ModelId': modelId,
        'Current': current,
        'ModelYear': modelYear,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postAiSettingsVehicleData(
requestBody?: AIVehicleDataInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ai-settings/vehicle-data',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @returns AIVehicleDataDto Success
   * @throws ApiError
   */
  public static getAiSettingsVehicleData1(
id: number,
): CancelablePromise<AIVehicleDataDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ai-settings/vehicle-data/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putAiSettingsVehicleData(
id: number,
requestBody?: AIVehicleDataInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/ai-settings/vehicle-data/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteAiSettingsVehicleData(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/ai-settings/vehicle-data/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putAiSettingsVehicleDataCurrentStatus(
id: number,
requestBody?: AIVehicleDataSetCurrentInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/ai-settings/vehicle-data/{id}/current-status',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns any Success
   * @throws ApiError
   */
  public static postAiSettingsVehicleDataFile(
id: number,
formData?: {
File?: Blob;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ai-settings/vehicle-data/{id}/file',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteAiSettingsVehicleDataFile(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/ai-settings/vehicle-data/{id}/file',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param regNo 
   * @returns ContractData Success
   * @throws ApiError
   */
  public static getAiSettingsVehicleDataVehicleContract(
branchId?: number,
regNo?: string,
): CancelablePromise<ContractData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ai-settings/vehicle-data/vehicle-contract',
      query: {
        'branchId': branchId,
        'regNo': regNo,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param search 
   * @param type 
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns AITemplateDtoPagedListData Success
   * @throws ApiError
   */
  public static getAiSettingsAiTemplate(
search?: string,
type?: number,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<AITemplateDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ai-settings/ai-template',
      query: {
        'Search': search,
        'Type': type,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @returns AITemplateDto Success
   * @throws ApiError
   */
  public static getAiSettingsAiTemplate1(
id: number,
): CancelablePromise<AITemplateDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ai-settings/ai-template/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putAiSettingsCreateAiTemplate(
requestBody?: AITemplateInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/ai-settings/create-ai-template',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putAiSettingsUpdateAiTemplate(
id: number,
requestBody?: AITemplateInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/ai-settings/update-ai-template/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteAiSettingsDeleteAiTemplate(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/ai-settings/delete-ai-template/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns AiAssistantCreateResponse Success
   * @throws ApiError
   */
  public static postAiSettingsAiTemplateCarDescriptionCreate(
requestBody?: AiAssistantCreateRequest,
): CancelablePromise<AiAssistantCreateResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ai-settings/ai-template/car-description-create',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns AiAssistantUpdateResponse Success
   * @throws ApiError
   */
  public static postAiSettingsAiTemplateCarDescriptionUpdate(
requestBody?: AiAssistantUpdateRequest,
): CancelablePromise<AiAssistantUpdateResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ai-settings/ai-template/car-description-update',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @param pdfUrl 
   * @param userId 
   * @returns ConvertedPartPdfFullModel Success
   * @throws ApiError
   */
  public static postAiSettingsPdfToJsonServiceParts(
soHeaderId: number,
pdfUrl?: string,
userId?: number,
): CancelablePromise<ConvertedPartPdfFullModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ai-settings/pdf-to-json/{soHeaderId}/service-parts',
      path: {
        'soHeaderId': soHeaderId,
      },
      query: {
        'pdfUrl': pdfUrl,
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

}
